import baseStyles from '../Base/Base.styles'

export default ({
  base,
  pillBackgroundColor,
  pillTextColor
}) => {

  let jss = {root: {
    ...baseStyles(base),
    '--pill-background-color': pillBackgroundColor,
    '--pill-text-color': pillTextColor
  }}

  return jss

}